import { render, staticRenderFns } from "./SelectLabels.vue?vue&type=template&id=4af0cc41&scoped=true"
import script from "./SelectLabels.vue?vue&type=script&lang=js"
export * from "./SelectLabels.vue?vue&type=script&lang=js"
import style0 from "./SelectLabels.vue?vue&type=style&index=0&id=4af0cc41&prod&lang=scss"
import style1 from "./SelectLabels.vue?vue&type=style&index=1&id=4af0cc41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0cc41",
  null
  
)

export default component.exports